import { uploadImage } from '../../services/api/uploadFile';

export const sharedUploadLogic = async (file: File) => {
  if (!file) {
    return {};
  }

  const fileUrl = await uploadImage(file);

  // The generic error handling in packages/graphdebate/src/components/Layout/MainLayout.tsx => applyErrorHandler is enough to notify the user.

  return {
    uploadedFile: fileUrl,
  };
};
